import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'components/Button';

interface DialogProps {
  open: boolean;
  onClose: () => void;
  maxRows: number;
  actualRows: number;
}

export function TooManyRowsWarning({ open, onClose, maxRows, actualRows }: DialogProps) {
  const intl = useIntl();

  const msg = intl.formatMessage(
    { id: 'articleVisibility.export.toomany.rowdetails' },
    {
      maxRows: <strong>{intl.formatNumber(maxRows)}</strong>,
      actualRows: <strong>{intl.formatNumber(actualRows)}</strong>,
    }
  );

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <div style={{ maxWidth: 732, maxHeight: 195 }} className="flex h-screen items-center mx-auto">
          <div style={{ width: 628, maxHeight: 147 }} className="flex h-screen items-center mx-auto">
            <img
              className="block max-w-fit mr-3"
              src="/illustrations/AlertDialogError.svg"
              alt="Something went wrong"
            />
            <div className="py-2">
              <div className="block-list text-left">
                <h4 className="text-base font-bold">
                  <FormattedMessage id="articleVisibility.export.toomany.title" />
                </h4>
                <p className="text-sm">{msg}</p>
                <br />
                <p className="text-sm">
                  <FormattedMessage id="articleVisibility.export.toomany.hint" />
                </p>
              </div>
            </div>
          </div>
          <div className="h-full py-2">
            <Button icon="Cross" aria-label="close" onClick={onClose} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
